import React from "react";
import DataTable from "../../../components/DataTable";
const dataJson = [
  {
    id: "d4fd5fd5",
    txnId: "dfsfsfnsrejfdd",
    amount: "$1254",
    growth: "$4888",
    remarks: "49",
    status: "pending",
    date: "15/03/2022",
  },
  {
    id: "7sf5df",
    txnId: "fuerfsjfj",
    amount: "$457",
    growth: "$4888",
    remarks: "75",
    status: "completed",
    date: "06/03/2022",
  },
  {
    id: "fdufsjf",
    txnId: "dfs7f8ds",
    amount: "$754",
    growth: "$4888",
    remarks: "787",
    status: "processing",
    date: "19/03/2022",
  },
];

const columns = [
  { id: "id", label: "ID #", minWidth: 20 },
  { id: "txnId", label: "Txn ID", minWidth: 100 },
  {
    id: "amount",
    label: "Amount (TRX)",
    minWidth: 80,
  },
  {
    id: "growth",
    label: "Growth",
    minWidth: 80,
  },
  {
    id: "remarks",
    label: "Remarks",
    minWidth: 80,
  },
  {
    id: "status",
    label: "Status",
    minWidth: 100,
  },
  {
    id: "date",
    label: "Date",
    minWidth: 80,
  },
];

function createData(id, txnId, amount, growth, remarks, status, date) {
  return {
    id,
    txnId,
    amount,
    growth,
    remarks,
    status,
    date,
  };
}

const rows = dataJson.map((d) =>
  createData(d.id, d.txnId, d.amount, d.growth, d.remarks, d.status, d.date)
);

const MyTopupHistoryTable = () => {
  return (
    <DataTable
      columns={columns}
      rows={rows}
      perPageShow={6}
      tableHeight={440}
      className="common_table"
    />
  );
};

export default MyTopupHistoryTable;
